var _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgId(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.1,
    y: 0.6,
    width: 13.8,
    height: 14.8,
    rx: 1.4,
    stroke: "#8D97AB",
    strokeWidth: 1.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.68383 11H4.5V5H5.68383V11Z",
    fill: "#8D97AB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4981 7.97472C11.4981 8.8764 11.5662 9.75281 10.8849 10.427C10.4846 10.823 9.91399 11 9.28375 11H7.09495V5H9.28375C9.91399 5 10.4846 5.17697 10.8849 5.57303C11.5662 6.24719 11.4981 7.07303 11.4981 7.97472ZM10.3143 7.97472C10.3143 7.06461 10.2802 6.68539 10.0588 6.41573C9.85437 6.17135 9.58184 6.04494 9.17303 6.04494H8.27878V9.95506H9.17303C9.58184 9.95506 9.85437 9.82865 10.0588 9.58427C10.2802 9.31461 10.3143 8.88483 10.3143 7.97472Z",
    fill: "#8D97AB"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgId);
export default __webpack_public_path__ + "static/media/ID.b28bac34c1e527bed5b0e4ff89504fc4.svg";
export { ForwardRef as ReactComponent };